export default {
  PLACEMENT: 'SHORT-TERM-MEDICAL-BUYERS-GUIDE',
  PRODUCT: 'STM'
}
